import React from "react";
import PreferencesNav from "./PreferencesNav";
import { addBrand, getCategoryKeyValue } from "../../services";
import { Toaster, toast } from "react-hot-toast";
import { useEffect } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { addCategory } from "../../services/Master/BrandService";

const Categories = () => {
    const [categoryList, setCategoryList] = useState(null);
    const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
    const [categoryTitle, setCategoryTitle] = useState("");

    useEffect(() => {
        getCategoryList();
    }, []);

    const getCategoryList = () => {
        getCategoryKeyValue().then((res) => {
            if (res.errorCode == 0) {
                setCategoryList(res.responsePacket);
            }
        });
    };

    const handleSave = () => {
        const obj = {
            title: categoryTitle,
        };
        if (categoryTitle === "") {
            toast("Please Provide Category Name");
            return;
        }
        addCategory(obj).then((res) => {
            if (res.errorCode == 0) {
                toast(res.message);
                getCategoryList();
                setShowAddCategoryModal(false);
                setCategoryTitle("");
            } else {
                toast(res.message);
            }
        });
    };

    return (
        <>
            {/* <div className="column list-column d-print-none column-small">
                <PreferencesNav />
            </div> */}
            <div className="column content-column">
                <div className="header clearfix" style={{ borderBottom: "none" }}>
                    <span className="float-left" style={{ fontSize: "35px" }}>
                        Item Category List
                    </span>
                </div>

                <div className="text-right mt-5 mr-4">
                    <button className="btn btn-primary mt-4" type="button" onClick={() => setShowAddCategoryModal(true)}>
                        <AddIcon />
                        New
                    </button>
                </div>
                <div className="m-4 p-3 border">
                    <Table striped className="customTable">
                        <tbody>
                            {categoryList &&
                                categoryList.map((category,i) => (
                                    <tr key={i}>
                                        <td>{category.value}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                </div>
            </div>
            <Modal show={showAddCategoryModal} onHide={() => setShowAddCategoryModal(false)} size="sm">
                <Modal.Header>Add Category</Modal.Header>
                <Modal.Body>
                    <table>
                        <tr>
                            <td>Title:</td>
                            <td>
                                <input autoComplete="off" className=" form-control" value={categoryTitle} name="title" onChange={(e) => setCategoryTitle(e.target.value)} />
                            </td>
                        </tr>
                    </table>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
            <Toaster />
        </>
    );
};

export default Categories;
